import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  sections: {
    [theme.breakpoints.up('sm')]: {
      backgroundColor: theme.palette.grey[100],
    },
  },
  grid: {
    padding: '0 !important',
  },
}));
